import type { Ref } from 'vue';
import type { INavigation } from '~/lib/ContentfulService';

export default defineNuxtPlugin(() => {
  const secondaryNavigation: Ref<INavigation | null> =
    useState<INavigation | null>('secondaryNavigation', () => null);

  return {
    provide: {
      secondaryNavigation
    }
  };
});
